import React from 'react';
import { Link } from 'react-router-dom';
import { Typography } from 'antd';
import { RocketOutlined } from '@ant-design/icons';

const { Text, Title } = Typography;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="main-footer nova-footer simple-footer">
      <div className="footer-container">
        <div className="footer-grid simple-footer-grid">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <span className="header-brand-icon"><RocketOutlined /></span>
              <span>CLOUNIQ</span>
            </Link>
            <Text className="footer-description">
              GPU and VPS infrastructure for product teams that need clear, fast deployment.
            </Text>
            <Text className="footer-description footer-company-info">
              -
              <br />
              Company number: -
              <br />
              -
            </Text>
          </div>

          <div className="footer-links footer-links-remix">
            <div className="footer-column">
              <Title level={5} className="footer-title">Platform</Title>
              <Link to="/" className="footer-link">Overview</Link>
              <Link to="/#solutions" className="footer-link">Solutions</Link>
              <Link to="/#pricing" className="footer-link">Pricing</Link>
              <Link to="/dashboard" className="footer-link">Dashboard</Link>
            </div>

            <div className="footer-column">
              <Title level={5} className="footer-title">Company</Title>
              <Link to="/contact" className="footer-link">Contact</Link>
              <Link to="/docs" className="footer-link">Docs</Link>
            </div>

            <div className="footer-column">
              <Title level={5} className="footer-title">Privacy</Title>
              <Link to="/privacy" className="footer-link">Privacy Policy</Link>
              <Link to="/terms" className="footer-link">Terms of Service</Link>
              <Link to="/refund" className="footer-link">Refund Policy</Link>
              <Link to="/shipping" className="footer-link">Shipping & Delivery</Link>
              <Link to="/cookies" className="footer-link">Cookie Policy</Link>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <Text className="footer-copyright">
            {currentYear} CLOUNIQ. Built for modern cloud operations.
          </Text>
          <div className="footer-payment-strip" aria-label="Accepted cards">
            <img src="/assets/visa.svg" alt="Visa" className="footer-payment-logo footer-payment-logo-visa" />
            <img src="/assets/mastercard.svg" alt="Mastercard" className="footer-payment-logo" />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;




